export default __webpack_public_path__ + "static/michigan-6-a6dcd08766843c69fd041677a5208da6.jpg";